import React, { FC, SyntheticEvent } from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'

import { toggleUpdateForeignProfileAction } from 'actions/foreignProfile/foreignProfileAction'
import { removeGiftAuthorAction } from 'actions/gifts/removeGiftAuthorAction'
import { ProfileHit } from 'common/constants'
import { FontSize, ToolTipSize } from 'common-constants/sizes'
import { SwitchName } from 'components/block/name/SwitchName'
import {
  Tooltip,
  UserDetails,
  tooltipTop,
} from 'components/block/PhotoLine/PhotoLineTooltip.styled'
import {
  GiftItemDescription,
  Message,
  WrapperButtonSignature,
} from 'components/page/ForeignProfile/Gifts/GiftDescription/GiftDescription.styled'
import { SvgContainer } from 'components/page/ProfileCommon/ProfileGift/ProfileGift.styled'
import { ProfileGiftDetails } from 'components/page/ProfileCommon/ProfileGift/ProfileGiftDetails'
import { ProfileGiftGreeting } from 'components/page/ProfileCommon/ProfileGift/ProfileGiftGreeting'
import { GiftTooltip } from 'components/page/UserProfile/UserProfileGifts/GiftTooltip'
import { SmallOrdinaryButton } from 'components/presentational/button'
import { NoPhoto } from 'components/presentational/NoPhoto/NoPhoto'
import { ProfileAvatar } from 'components/presentational/ProfileAvatar/ProfileAvatar'
import { ProfileInfo } from 'components/presentational/ProfileInfo/ProfileInfo'
import { ProfileLink } from 'components/presentational/ProfileLink/ProfileLink'
import { CenterTooltip } from 'components/presentational/Tooltip'
import { zIndex } from 'components/presentational/zIndex'

import { GQLForeignRootQuery } from '../../gql/__generated__/ForeignRoot'

export const GiftDescription: FC<{
  giftId: number
  greeting: string
  authorProfile: NonNullable<
    GQLForeignRootQuery['user']
  >['gifts']['gifts']['nodes'][0]['senderProfile']
  isAuthorHidden: boolean
  left: number
  top: number
  isGiftFromCurrentUser?: boolean
}> = ({
  giftId,
  greeting,
  authorProfile,
  isAuthorHidden,
  left,
  top,
  isGiftFromCurrentUser,
}) => {
  const dispatch = useDispatch()

  const handleRemoveSignature = async (
    event: SyntheticEvent<Element, Event>
  ) => {
    event.preventDefault()
    await dispatch(removeGiftAuthorAction(giftId))
    dispatch(toggleUpdateForeignProfileAction(true))
  }

  /**
   * TODO: проверить
   * в GQL если isAuthorHidden:true то authorProfile не придет.
   * Но нужно проверить
   */
  if (authorProfile && !isAuthorHidden && !authorProfile.deleted) {
    return (
      <GiftItemDescription
        $left={left}
        $top={top}
        data-name={`${giftId}-gift-id-tooltip`}
        data-tooltip="gift-tooltip"
      >
        <CenterTooltip
          style={{ top: tooltipTop, zIndex: zIndex.overAdvertising + 1 }}
        >
          <Tooltip style={{ width: `${ToolTipSize.gift}px` }}>
            <ProfileLink
              id={authorProfile.id}
              data-name={`profile-${authorProfile.id}-action`}
              hit={ProfileHit.GIFT_HIT}
            >
              <ProfileInfo
                icon={
                  <ProfileAvatar
                    srcAvatar={authorProfile.photos.default?.urls?.square}
                    gender={authorProfile.gender}
                    type="avatar-gift"
                    id={`${String(authorProfile.id)}-${giftId}`}
                  />
                }
                locationShow={true}
                locationName={authorProfile.relations.spaceTimeLocation!.text}
                message={<Message>{greeting}</Message>}
                fontSize={FontSize.text}
                title={
                  <UserDetails>
                    <SwitchName
                      name={authorProfile.name}
                      age={authorProfile.age!}
                      onlineStatus={authorProfile.online?.status}
                      verifiedPhotos={authorProfile.verification.verifiedPhotos}
                    />
                  </UserDetails>
                }
                buttonRemoveGift={
                  isGiftFromCurrentUser && (
                    <WrapperButtonSignature>
                      <SmallOrdinaryButton
                        onClick={handleRemoveSignature}
                        data-name={`${giftId}-remove-signature-action`}
                      >
                        <FormattedMessage
                          id="profile.gift.hide_author"
                          defaultMessage="Скрыть имя и подпись"
                        />
                      </SmallOrdinaryButton>
                    </WrapperButtonSignature>
                  )
                }
              />
            </ProfileLink>
          </Tooltip>
        </CenterTooltip>
      </GiftItemDescription>
    )
  }

  return (
    <GiftItemDescription
      $left={left}
      $top={top}
      data-name={`${giftId}-gift-id-tooltip`}
      data-tooltip="gift-tooltip"
    >
      <GiftTooltip
        userPhotoGift={
          <SvgContainer>
            <NoPhoto id={giftId} gender={authorProfile?.gender} />
          </SvgContainer>
        }
        userDetails={
          <ProfileGiftDetails
            isGiftFromCurrentUser={isGiftFromCurrentUser!}
            state={authorProfile?.deleted!}
          />
        }
        message={
          <ProfileGiftGreeting
            isAuthorHidden={isAuthorHidden}
            greeting={greeting}
          />
        }
      />
    </GiftItemDescription>
  )
}
